module.exports = __webpack_public_path__ + "img/img08.5a71f98c.svg";